import { MODALS_DATA_URL } from '../../constants/apiUrls/apiUrls';
import forResponse from '../../utils/forResponse';
import http from '../../services/http';


export const dismissModal = (payload) => forResponse(http.post(MODALS_DATA_URL, payload));
